import Image from 'next/image';
import { H3, H4, H5, H6, Label } from './text';

interface IMediaObject {
	title: string;
	subtitle: string;
	imageUrl: string;
	mediaAlignment?: 'left' | 'right';
}
export default function MediaObject({ title, imageUrl, subtitle, mediaAlignment = 'left' }: IMediaObject) {
	return (
		<div
			className={`relative flex items-center space-x-4 px-6 py-2  ${
				mediaAlignment === 'right' ? 'flex-row-reverse text-right' : ''
			}`}
		>
			<div className="flex-shrink-0">
				<Image alt={title} src={imageUrl} className="h-20 w-20 object-contain" width={512} height={512} />
			</div>
			<div className="min-w-0 flex-1">
				{/* Wrap in link */}
				<div>
					<H6 className="mb-1 !text-lg">{title}</H6>
					<Label className="truncate">{subtitle}</Label>
				</div>
			</div>
		</div>
	);
}
